import { PaintedScene } from '../PaintedScene';

export const THE_LOW_WALL_PHASER_KEY = 'TheLowWallScene' as const;
export const THE_LOW_WALL_MANIFEST_KEY = 's-010-the-low-wall' as const;

export class TheLowWallScene extends PaintedScene {
  constructor() {
    super(THE_LOW_WALL_PHASER_KEY, THE_LOW_WALL_MANIFEST_KEY);
  }
}
